












import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
	public year = new Date().getFullYear()
}
